import { format } from 'owa-strings';

const CDN_URL_FORMAT = 'https://r{0}.res.outlook.com/owa/prem/images/{1}.png';
let count: number = 1; // Use this to spread traffic to r1, r2, r3 and r4 endpoints.
export default function getCDNIconUrl(icon: string): string {
    return format(CDN_URL_FORMAT, (count++ % 4) + 1, icon);
}
